export default __webpack_public_path__ + "static/media/ETEF-4-5.5d33e14e.pdf";